import { getItem } from 'owa-local-storage';

export const ACTIONS_QUEUED_HINT_KEY = 'ActionsQueuedHint';

// Load the hint from local storage indicating whether there are queued actions
export function getActionsQueuedHint(): boolean {
    return getItem(self, ACTIONS_QUEUED_HINT_KEY) === 'true';
}
